import { IonModal } from '@ionic/react';
import styled from 'styled-components';
import { AllieModalProps } from './Modal.types';
import { isMobile } from '../../common/utils';

const defaultHeight = isMobile ? '100%' : 'auto';
const defaultWidth = isMobile ? '100%' : 'auto';

export const StyledModal: any = styled(IonModal)<AllieModalProps>`
  --height: ${(props: AllieModalProps) => (props.height ? props.height : defaultHeight)};
  --width: ${(props: AllieModalProps) => (props.width ? props.width : defaultWidth)};
  --ion-backdrop-opacity: ${(props: AllieModalProps) => props.backdropOpacity ?? 0.4};
  --border-radius: ${(props: AllieModalProps) =>
    props.radius ? `var(--allie-radius-${props.radius})` : 0};
  ${(props: AllieModalProps) => (props.maxHeight ? `--max-height: ${props.maxHeight};` : '')}
`;
